import React from 'react';
import { createPortal } from 'react-dom';

function LinkCopiedToast({ visible, message }) {
  return createPortal(
    <div
      role="status"
      aria-live="polite"
      aria-hidden={!visible}
      className={`fixed bottom-6 left-1/2 z-[300] -translate-x-1/2 transition-all duration-200 ease-out ${
        visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-2 pointer-events-none'
      }`}
    >
      <div className="flex items-center gap-2 rounded-lg bg-gray-900 px-4 py-2.5 text-sm font-medium text-white shadow-lg">
        <svg className="h-4 w-4 shrink-0 text-green-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden>
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M5 13l4 4L19 7" />
        </svg>
        <span>{message}</span>
      </div>
    </div>,
    document.body
  );
}

export default LinkCopiedToast;
